import { PlayerStates } from 'data/VideoPlayer'
import PlayerWrapper from 'components/set/InteractionPlayer/PlayerWrapper/PlayerWrapper'
import React from 'react'
import Spinner from 'react-spinkit'
import { useTheme } from '@material-ui/core/styles'
import { Theme } from 'styling/theme'

const LoadingAnimation: React.FC = () => {
    const theme: Theme = useTheme()
    return (
        <PlayerWrapper stateId={PlayerStates.LOADING}>
            <Spinner name="line-scale-pulse-out-rapid" color={theme.colors.orange} />
        </PlayerWrapper>
    )
}

export default LoadingAnimation
